// Vídeo de apresentação (tour de 2 min). Arquivo em public/tour, servido junto com o sistema.
import { useEffect, useState, type ReactNode } from 'react';

export const TOUR_VIDEO = '/tour/garimpa-vendas-tour.mp4';
export const TOUR_VIDEO_WEBM = '/tour/garimpa-vendas-tour.webm';
export const TOUR_CAPA = '/tour/garimpa-vendas-tour.jpg';

export function IconePlay({ size = 16 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" style={{ flex: 'none' }}>
      <circle cx="12" cy="12" r="11" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <path d="M10 8.2v7.6l6-3.8z" fill="currentColor" />
    </svg>
  );
}

function JanelaVideo({ onClose }: { onClose: () => void }) {
  useEffect(() => {
    const esc = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', esc);
    return () => window.removeEventListener('keydown', esc);
  }, [onClose]);
  return (
    <div className="overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <section className="modal modal-video" role="dialog" aria-modal="true" aria-label="Veja como funciona">
        <div className="modal-head">
          <h2>Veja como funciona · 2 min</h2>
          <button type="button" className="btn icon-btn" style={{ marginLeft: 'auto' }} aria-label="Fechar" onClick={onClose}>×</button>
        </div>
        <video poster={TOUR_CAPA} controls autoPlay playsInline preload="metadata">
          <source src={TOUR_VIDEO_WEBM} type="video/webm" />
          <source src={TOUR_VIDEO} type="video/mp4" />
          Seu navegador não reproduz vídeos. <a href={TOUR_VIDEO}>Baixe o vídeo</a>.
        </video>
      </section>
    </div>
  );
}

/** Botão que abre o tour numa janela sobre a página. */
export function BotaoTour({ className = 'btn', children }: { className?: string; children?: ReactNode }) {
  const [aberto, setAberto] = useState(false);
  return (
    <>
      <button type="button" className={className} onClick={() => setAberto(true)}>
        {children ?? <><IconePlay />Veja como funciona (2 min)</>}
      </button>
      {aberto && <JanelaVideo onClose={() => setAberto(false)} />}
    </>
  );
}

/** Card com a capa do vídeo (Primeiros passos). */
export function CardTour() {
  const [aberto, setAberto] = useState(false);
  return (
    <section className="card" aria-labelledby="h-tour" style={{ gap: 12 }}>
      <h2 id="h-tour">Assista ao tour</h2>
      <button type="button" className="tour-capa" onClick={() => setAberto(true)} aria-label="Assistir ao vídeo de apresentação, 2 minutos">
        <img src={TOUR_CAPA} alt="" />
        <span className="tour-play"><IconePlay size={44} /></span>
      </button>
      <span className="small muted">Em 2 minutos: garimpar clientes, mandar WhatsApp, registrar contato e agendar retorno.</span>
      {aberto && <JanelaVideo onClose={() => setAberto(false)} />}
    </section>
  );
}
